export const REFERRAL_TYPE = {
  ALL_REFERRAL: 'ALL_REFERRAL',
  EMPLOYEE_SHARED: 'EMPLOYEE_SHARED',
  CANDIDATE_SHARED: 'CANDIDATE_SHARED',
  EMPLOYEE_SUBMITTED: 'EMPLOYEE_SUBMITTED',
  CANDIDATE_SUBMITTED: 'CANDIDATE_SUBMITTED',
  NO_REFERRAL: 'NO_REFERRAL'
}

export const ACADEMIC_RATING = {
  TOP5: 5,
  TOP10: 10,
  TOP20: 20,
  TOP30: 30,
  OTHER: 40
}

export function generateFitEchartsOption (name, value, lineColor, textSize = 36, textColor = '#606266', backgroundColor = '#DCDFE6', circle = 10) {
  return {
    series: {
      type: 'gauge',
      startAngle: 90,
      endAngle: -270,
      radius: '100%', // 半径设为容器宽高中最小值一半的100%
      center: ['50%', '50%'], // 中心点位置设为容器中心
      pointer: {
        show: false
      },
      progress: {
        show: value !== null, // now(2023-02-28) echarts 5.2.1 is not support: auto hide progress line when value is 'null'
        overlap: false,
        roundCap: true,
        clip: false
      },
      colorBy: 'data',
      axisLine: { // 仪表盘轴线，即圆环
        lineStyle: {
          width: circle,
          color: [[1, backgroundColor]] // 圆环背景色
        }
      },
      splitLine: { // 分割线
        show: false
      },
      axisTick: { // 刻度
        show: false
      },
      axisLabel: { // 刻度标签
        show: false
      },
      data: [{
        value: value,
        name: name,
        title: {
          offsetCenter: [0, '5%'],
          fontSize: textSize,
          fontWeight: 'bold',
          color: textColor
        },
        itemStyle: {
          color: lineColor // 圆环的颜色
        }
      }],
      detail: {
        show: false
      }
    }
  }
}

export const SQUARED_UP_MAP = {
  1: {
    personalityFit: [0, 3.3],
    cultureFit: [0, 3.3]
  },
  2: {
    personalityFit: [3.3, 6.6],
    cultureFit: [0, 3.3]
  },
  3: {
    personalityFit: [6.6, 10],
    cultureFit: [0, 3.3]
  },
  4: {
    personalityFit: [0, 3.3],
    cultureFit: [3.3, 6.6]
  },
  5: {
    personalityFit: [3.3, 6.6],
    cultureFit: [3.3, 6.6]
  },
  6: {
    personalityFit: [6.6, 10],
    cultureFit: [3.3, 6.6]
  },
  7: {
    personalityFit: [0, 3.3],
    cultureFit: [6.6, 10]
  },
  8: {
    personalityFit: [3.3, 6.6],
    cultureFit: [6.6, 10]
  },
  9: {
    personalityFit: [6.6, 10],
    cultureFit: [6.6, 10]
  }
}

export const STATUS_STAGE = {
  SCREEN: 'SCREEN',
  INTERVIEW: 'INTERVIEW',
  OFFER: 'OFFER',
  HIRED: 'HIRED'
}

export const ASSESSMENT_INVITE_TYPE = {
  PERSONALITY: 1,
  PROBLEM_SOLVING: 2
}

export const READ_STATUS = {
  READ: '1',
  UNREAD: '0'
}

export const HIDE_STATUS = ['Video Application Invited', 'Video Application Finished', 'Invited Hiring Manager to review',
  'Hiring Manager Finished Rating', 'Interview Invitation Sent', 'Interview Rating Finished', 'Submitted',
  'Onboarding Form Invited', 'Onboarding Form Finished', 'Onboarding Form Cancelled', 'b18d80ec-15f5-11f1-8589-00163e146fe1', 'bd0727ac-15f5-11f1-9466-00163e146fe1']

export const APPLICATION_STATUS = {
  FINISHED: 'FINISHED',
  UNFINISHED: 'UNFINISHED'
}

export const MUNICIPALITY_CITY = {
  CHONG_QIN: 126,
  TIAN_JIN: 128,
  SHANG_HAI: 131,
  BEI_JIN: 112
}

export const MUNICIPALITY_PROVINCE = {
  CHONG_QIN: 9,
  TIAN_JIN: 11,
  SHANG_HAI: 7,
  BEI_JIN: 5
}

export const GENDER = {
  MALE: 'M',
  FEMALE: 'F',
  NON_BINARY: 'N',
  PREFER_NOT_TO_DISCLOSE: 'P'
}

export const CONSENT_STATUS = {
  AGREED: 1,
  PENDING: 2
}

export const PROBLEM_SOLVING_FIT_RANGE_BAR = {
  count_null: null,
  count_1: [-1, 0.1],
  count_2: [0.1, 0.3],
  count_3: [0.3, 0.7],
  count_4: [0.7, 0.9],
  count_5: [0.9, 1.1]
}

export const CONTACT_STATUS = {
  HAS_CONTACTED: '1',
  NO_CONTACTED: '0'
}

export const COMPLETED_APPLICATION = 'completed'
export const INCOMPLETE_APPLICATION = 'incomplete'

export const AI_COMPARISON_TASK_STATUS = {
  START: 'START',
  REVIEW: 'REVIEW',
  READING: 'READING',
  COMPARING: 'COMPARING',
  THINKING: 'THINKING',
  WRITING: 'WRITING'
}

export const AI_PARSE_TASK_STATUS = {
  START: 'START',
  REVIEW: 'REVIEW',
  READING: 'READING',
  EXTRACTION: 'EXTRACTION',
  FORMATING: 'FORMATING',
  WRITING: 'WRITING'
}

export const AI_PARSE_MAX_COUNT = 180

export const MAX_UPLOAD_RESUME_FILE_SIZE = 1024 * 1024 * 10 // 10MB

export const READY_TO_HIRE_STATUS_LIST = [
  '6cc1127e-62d2-11ec-930c-00163e0fbcc2',
  'd71f06b8-4a32-11ef-94be-00163e0fbcc2'
]

export const HIRED_STATUS = 'Hired'

export const ON_RETAILS_EMPLOYEE_TYPE_LIST = [
  'Store, Regular',
  'Store, Regular Fixed (Fixed Term)',
  'Store, Seasonal (Fixed Term) (Seasonal)',
  'Store, Self-employed',
  'Store, Student'
]

export const ON_RETAILS_USER_EMAIL_SUFFIX = '@on-running.com'
